<template>
  <!-- <div class="white pa-0" > -->
    <!-- <v-row class="text-center px-0"> -->

       <!-- ряд 4 -->
      <v-col class="deep-orange darken-1 pb-2 py-0" cols="12">
        <div dark class="deep-orange darken-1" style="height: 70px"></div>
        <h2
          class="deep-orange darken-1 headline font-weight-bold px-4 mb-3 other-element white--text"
          style="letter-spacing: 0.13125em !important"
        >
          КАК ПОМОЧЬ ПРИЮТУ
        </h2>
        <v-divider
          class="white mx-auto"
          light
          style="min-height: 3px; max-width: 50px"
        ></v-divider>
        <div class="deep-orange darken-1" style="height: 40px"></div>
        <v-row justify="center" no-gutters>


          <!-- ряд 4 сектор 1 -->
          <v-col
            class="deep-orange darken-1 px-5 col-md-4 offset-md-0 col-12 offset-0"
          >
            <div
              class="ma-0 pa-0"
              data-aos="fade-up"
              data-aos-offset="100"
              data-aos-delay="1"
              data-aos-duration="700"
              data-aos-easing="ease-in-out"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-anchor-placement="top-bottom"
            >
              <v-card-title
                class="white--text textTimelineHeaders textWordBreak ml-md-16"
              >
                Мы очень нуждаемся:
              </v-card-title>
              <div class="justify-center align-center text-center">
                <v-timeline
                  class="overline white--text ml-md-16"
                  align-center
                  dense
                >
                  <v-timeline-item
                    class="text-left textTimelines"
                    data-aos="fade-up"
                    data-aos-offset="100"
                    data-aos-delay="1"
                    data-aos-duration="700"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="false"
                    data-aos-anchor-placement="bottom-bottom"
                    ><div class="mt-2">
                      в помощи по поиску нового дома для наших питомцев
                    </div>
                  </v-timeline-item>
                  <v-timeline-item
                    class="text-left textTimelines"
                    data-aos="fade-up"
                    data-aos-offset="100"
                    data-aos-delay="100"
                    data-aos-duration="700"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="false"
                    data-aos-anchor-placement="bottom-bottom"
                    ><div class="mt-2">временной передержке животных</div>
                  </v-timeline-item>
                  <v-timeline-item
                    class="text-left textTimelines"
                    data-aos="fade-up"
                    data-aos-offset="100"
                    data-aos-delay="200"
                    data-aos-duration="700"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="false"
                    data-aos-anchor-placement="bottom-bottom"
                    ><div class="mt-2">
                      крепких мужских руках для помощи по хозяйству
                    </div>
                  </v-timeline-item>
                  <v-timeline-item
                    class="text-left textTimelines"
                    data-aos="fade-up"
                    data-aos-offset="100"
                    data-aos-delay="300"
                    data-aos-duration="700"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="false"
                    data-aos-anchor-placement="bottom-bottom"
                    ><div class="mt-2">
                      транспортировке животных, продуктов и прочего (автоволонтеры)
                    </div>
                  </v-timeline-item>
                </v-timeline>
              </div>
            </div>
          </v-col>

          

          <!-- ряд 4 сектор 2 -->
          <v-col
            class="deep-orange darken-1 px-5 col-md-4 offset-md-0 col-12 offset-0"
          >
            <!-- class="deep-orange darken-1 px-5 col-md-5 offset-md-0 col-12 offset-0 " -->
            <!-- <div style="height: 70px"></div> -->
            <div
              class="ma-0 pa-0"
              data-aos="fade-up"
              data-aos-offset="100"
              data-aos-delay="1"
              data-aos-duration="700"
              data-aos-easing="ease-in-out"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-anchor-placement="top-bottom"
            >
              <v-card-title
                class="white--text textTimelineHeaders textWordBreak ml-md-16"
              >
                Каждый день нужно минимум:
              </v-card-title>
              <v-timeline
                class="overline white--text ml-md-16"
                align-center
                dense
              >
                <v-timeline-item
                  class="text-left textTimelines"
                  data-aos="fade-up"
                  data-aos-offset="100"
                  data-aos-delay="1"
                  data-aos-duration="700"
                  data-aos-easing="ease-in-out"
                  data-aos-mirror="true"
                  data-aos-once="false"
                  data-aos-anchor-placement="bottom-bottom"
                  ><div class="mt-2">25 кг крупы</div>
                </v-timeline-item>
                <v-timeline-item
                  class="text-left textTimelines"
                  data-aos="fade-up"
                  data-aos-offset="100"
                  data-aos-delay="100"
                  data-aos-duration="700"
                  data-aos-easing="ease-in-out"
                  data-aos-mirror="true"
                  data-aos-once="false"
                  data-aos-anchor-placement="bottom-bottom"
                  ><div class="mt-2">30 кг мяса</div>
                </v-timeline-item>
              </v-timeline>
            </div>
            <!-- <div style="height: 70px"></div> -->
          </v-col>

          <!-- ряд 4 сектор 3 -->
          <v-col
            class="deep-orange darken-1 px-5 col-md-4 offset-md-0 col-12 offset-0"
          >
            <!-- class="deep-orange darken-1 px-5  col-md-5 offset-md-0 col-12 offset-0 " -->
            <div
              class="ma-0 pa-0"
              data-aos="fade-up"
              data-aos-offset="100"
              data-aos-delay="1"
              data-aos-duration="700"
              data-aos-easing="ease-in-out"
              data-aos-mirror="true"
              data-aos-once="false"
              data-aos-anchor-placement="top-bottom"
            >
              <v-card-title
                class="white--text textTimelineHeaders textWordBreak ml-md-16"
              >
                Постоянно необходимы средства на:
              </v-card-title>
              <div class="justify-center align-center text-center">
                <v-timeline
                  class="overline white--text ml-md-16"
                  align-center
                  dense
                >
                  <v-timeline-item
                    class="text-left textTimelines"
                    data-aos="fade-up"
                    data-aos-offset="100"
                    data-aos-delay="1"
                    data-aos-duration="700"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="false"
                    data-aos-anchor-placement="bottom-bottom"
                    ><div class="mt-2">стерилизацию, операции, лекарства</div>
                  </v-timeline-item>
                  <v-timeline-item
                    class="text-left textTimelines"
                    data-aos="fade-up"
                    data-aos-offset="100"
                    data-aos-delay="100"
                    data-aos-duration="700"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="false"
                    data-aos-anchor-placement="bottom-bottom"
                    ><div class="mt-2">средства от глистов, блох, клещей</div>
                  </v-timeline-item>
                  <v-timeline-item
                    class="text-left textTimelines"
                    data-aos="fade-up"
                    data-aos-offset="100"
                    data-aos-delay="200"
                    data-aos-duration="700"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="false"
                    data-aos-anchor-placement="bottom-bottom"
                    ><div class="mt-2">ошейники, цепи, карабины, вертушки</div>
                  </v-timeline-item>
                  <v-timeline-item
                    class="text-left textTimelines"
                    data-aos="fade-up"
                    data-aos-offset="100"
                    data-aos-delay="300"
                    data-aos-duration="700"
                    data-aos-easing="ease-in-out"
                    data-aos-mirror="true"
                    data-aos-once="false"
                    data-aos-anchor-placement="bottom-bottom"
                    ><div class="mt-2">
                      оплату аренды территории, привозной воды и газа
                    </div>
                  </v-timeline-item>
                </v-timeline>
              </div>
            </div>
          </v-col>
          
        </v-row>
        <!-- <div style="height: 40px"></div> -->

        <v-row justify="center">
          <div class="justify-center align-center text-center mb-13 mt-7">
            <v-btn
              class="btnStyle ml-2"
              rounded
              color="orange"
              dark
              large
              elevation="6"
               @click="goTo('sos')"
              data-aos="fade-up"
              data-aos-offset="100"
              data-aos-delay="10"
              data-aos-duration="1500"
              data-aos-easing="ease-out-back"
              data-aos-once="false"
              data-aos-anchor-placement="top-bottom"
            >
           
              ПРОТЯНИ<v-icon class="mx-3 brown--text" size="35">mdi-paw</v-icon> ПОМОЩИ
            </v-btn>
          </div>
        </v-row>
      </v-col>

    <!-- </v-row> -->
  <!-- </div> -->
</template>



<script>
export default {
  name: "SectionFour",
  methods: {
    goTo(value) {
      this.$router.push(value).catch(() => {});
    },
  },
};
</script>

